/**
 * Angular imports.
 */
import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, OnChanges, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../../../dataservices/master-service/masterservice.service';
import { MultiLangService } from '../../../../dataservices/master-service/multi-lang.service';
import { PostApiService } from '../../../../dataservices/post-api.service';
import { DataStorageService } from '../../../../dataservices/data-storage.service';
import { JwtDecodeService } from '../../../../dataservices/jwt-decode.service';
import { GetService } from '../../../../dataservices/get.service';
import { NewLanguageService } from '../../../../dataservices/new-language/new-language.service';
import { ImageGroupService } from 'src/app/dataservices/master-service/image-group.service';


/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Constant import.
 */
import { EVENT_NAME } from '../../../../analytics-event/analytics.constant';
import { COMMENT_LIST_TYPE, FILTER_NAME, SCREEN_NAME, PRODUCT_TYPE_CONSTANT, TEMPLATE_TYPE, CREATE_STORY_TYPES, STORY_CREATION_TYPE, REPOST_TYPE_ITEM, POSTING_PROGRESS, REPOST_STATUS, NUMBERS, POST_TYPE, REPOST_INFO_LOCAL_STORAGE, USER_STORY_NUDGE, ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME, PRODUCT_TYPE_NUMBER_MAPPING } from './../../../../constants/app.constants';
import { DOC_TALKS_CARD } from './../../../../constants/data-testId.constants';
import { CLICK, CLICK_SUB, LIKE } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../../../analytics-event/analytics.model';
import { CommunityObject } from '../../../../onboarding/interface/global.model';

/**
 * SDK imports
 */
import { Analytics } from 'analytics2.0';
/**
 * Web Doctalk Card Component
 */
@Component({
  selector: 'app-web-doctalk-card',
  templateUrl: './web-doctalk-card.component.html',
  styleUrls: ['./web-doctalk-card.component.scss']
})
export class WebDoctalkCardComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  public doctalk_user_image = {
    prflclass: '',
    prflpic: '',
    prflfname: '',
    prflmname: '',
    prfllname: '',
    prflrname: '',
    prflcid: '',
    prfltype: '',
    prflpicclass: 'c-profile-pic rounded-circle box-size-56 post-pic',
    anonymous: '0',
    partial_permission_state: ''
  };
  @Input() callingfrom;
  @Input() docCardObj;
  @Input() docTalkSection;
  @Input() listLength;
  @Input() doctalkIdx;
  @Input() singlecardlike;
  public playTime: string;
  public feed_bookmark_loader = false;
  public feed_like_loader = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public width: any;
  public speclility_name = '';
  public ngbDDL: object;
  public showLikeListModal = false;
  public showSubscribeModal = false;
  public runOnce = false;
  public subscribe_obj: object;
  public likeObj;
  public channelsub: object;

  /**
   * Data test id for the doc talks card.
   */
  public dataTestId = DOC_TALKS_CARD;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Analytics object.
   */
  public analyticsData: AnalyticsInterface;
  /**
   * Screen name from which that octalk card is called.
   */
  @Input() screenName?: string;

  @Input() parentEntityType: string;
  @Input() parentEntityCode;
  /**
   * Get speciality list as string for CT.
   */
   public speciality = '';

   /**
   * For storing screen name constant
   */
    public screen = SCREEN_NAME;
  /**
   * Create repost screen
   */
    public createRepostScreen = SCREEN_NAME.CREATE_REPOST;
    /**
     * create user story screen
     */
    public createUserStoryScreen = SCREEN_NAME.CREATE_USER_STORY;
  /**
   * Key used to get comment list type.
   */
    public commentListType = COMMENT_LIST_TYPE;
  /**
   * Community Object for comment on GR.
   */
    public commentObj : CommunityObject ;
  /**
   * Constant for screen names
   */
    public comment_box_obj = { profile_pic: '', product_type_id: '', product_id: '' };
  /**
   * Constant for numbers
   */
    public numbers = NUMBERS;

  /**
   * Repost info popover status.
   */
   public showRepostPopOver = false;
   public isMetaGenerated = false;
   public productTypeConstant = PRODUCT_TYPE_CONSTANT;




  /**
   * Necessary instances.
   */
  constructor(
    private GetService: GetService,
    private masterService: MasterserviceService,
    public multiLangService: MultiLangService,
    private router: Router,
    public fcs: FunCollectionService,
    public postSer: PostApiService,
    private dss: DataStorageService,
    private jwtSer: JwtDecodeService,
    private cdr: ChangeDetectorRef,
    public mls: NewLanguageService,
    public igs: ImageGroupService,
    private analyticSdk: Analytics
  ) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.commentObj = {
      'product_id': this.docCardObj.doctalks_id,
      'product_type': PRODUCT_TYPE_CONSTANT.DOCTALKS,
      'comment': this.docCardObj['comment_list'],
      'comment_count': this.docCardObj['commentCount'],
      'kind': ''
    };
    if (this.docCardObj.channel != null) {
      this.subscribe_obj = {
        'target_id': this.docCardObj.channel.target_id,
        'channel_name': this.docCardObj.channel.title,
        'tnc_url': this.docCardObj.channel.tnc_url,
        'target_name': this.docCardObj.channel.powered_name,
        'target_label': this.docCardObj.channel.powered_by_label,
        'publication_logo': this.docCardObj.channel.channel_logo,
        'sponsor_footer_text': this.docCardObj.channel.sponsor_footer_text,
        'no_of_members': this.docCardObj.channel.no_of_members,
        'safe_url': this.docCardObj.channel.safe_url,
        'product_view': this.docCardObj.channel.is_product_view,
        'calling_from': 'cme_list',
        'target_id_clinical_detail': this.docCardObj.course_id

      };

    }

    this.subscriptions.add(this.GetService.doctalkseriesbookmark.subscribe(data => {
      if (data.action_for == 'bookmark' && data.product_id == this.docCardObj.doctalks_id) {
        this.docCardObj.is_bookmarks = data.bookmarked;
      }
    }));

    this.subscriptions.add(this.GetService.doctalkserieslike.subscribe(data => {
      if (data.action_for == 'like' && data.product_id == this.docCardObj.doctalks_id) {
        this.docCardObj.is_like = 1;
        this.feed_like_loader = false;
      }
    }));

    /**
     * Analytics event object.
     */
    if (this.callingfrom) {
      /**
       * Get specilty list for analytics.
       */
      if (this.docCardObj.speciality?.length > 0) {
        const specialityList = this.docCardObj.speciality;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const arrayColumn = (array: any[], column: string): any[] => {
          return array.map(item => item[column]);
        };
        const specialityNames = arrayColumn(specialityList, FILTER_NAME.speciality_name);
        this.speciality = specialityNames.join(',');
      }
      this.analyticsData = {
        'event_name': EVENT_NAME.DOCTALK_CARD_CLICK,
        'product_type': this.docCardObj.product_type,
        'product_type_id': this.docCardObj.product_type_id,
        'screen_name': this.callingfrom,
        'Specialty': this.speciality
      };
    }
      this.comment_box_obj.product_type_id = PRODUCT_TYPE_CONSTANT.DOCTALK_STRING;
      this.comment_box_obj.product_id = this.docCardObj.product_type_id;

        /**
     * Check if we need to show repost tolltip or not.
     */
        if(localStorage.getItem(REPOST_INFO_LOCAL_STORAGE.KEY) !== NUMBERS.ONE.toString() && this.docCardObj?.showRepostTooltip === this.dss.reposTooltip &&
        this.docCardObj?.channel?.content_visibility?.display !== NUMBERS.ZERO && this.docCardObj?.channel?.content_visibility?.display !== NUMBERS.TWO){
          this.showRepostPopOver = true;
        }
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    this.doctalk_user_image.prflpic = this.docCardObj.profile_pic;
    this.doctalk_user_image.prflfname = this.docCardObj.name;
    this.doctalk_user_image.partial_permission_state = this.docCardObj.partial_permission_state;
    this.initializeNgbDdl();
  }

  /**
   * initialize NgbDdl
   */
  initializeNgbDdl(): void {
    this.ngbDDL = {
      class: 'm', calling_from: 'doctalk card',
      data: [
        { index: 0, action: 'report', text: this.mls.languageText.doctalk_card.key12, product_type: this.docCardObj.product_type, product_type_id: this.docCardObj.doctalks_id },
        { index: 1, action: 'share', text: this.mls.languageText.doctalk_card.key13, product_type: this.docCardObj.product_type, product_type_id: this.docCardObj.doctalks_id },
      ]
    };
  }

  /**
   * ngAfterViewInit
   */
  ngAfterViewInit(): void {
    if (this.docCardObj.media != undefined && this.docCardObj.media.length > 0) {
      // tslint:disable-next-line: radix
      this.width = (this.docCardObj.media[0].play_time != 0) ? ((parseInt(this.docCardObj.media[0].resume_on_in_sec) * 100 * 1000) / parseInt(this.docCardObj.media[0].play_time)) + '%' : '0%';
      // tslint:disable-next-line: radix
      this.width = parseInt(this.width) + '%';
      this.playTime = this.fcs.millisToMinutesAndSeconds(this.docCardObj.media[0].play_time);
    }
    this.subscriptions.add(this.dss.series_video.subscribe(data => {
      if (data['media_id'] == this.docCardObj.media[0].media_id) {
        this.docCardObj.media[0].resume_on_in_sec = data['stop_time'];
        // tslint:disable-next-line: radix
        this.width = (this.docCardObj.media[0].play_time != 0) ? ((parseInt(this.docCardObj.media[0].resume_on_in_sec) * 100 * 1000) / parseInt(this.docCardObj.media[0].play_time)) : 0;
        // tslint:disable-next-line: radix
        this.width = parseInt(this.width) + '%';

        this.cdr.detectChanges();

      }
    }));

  }

  /**
   * product Share
   */
  productShare(share_content, product_type, product_type_id): void {
    const x = [{ share_url: '', share_contentt: share_content, product_type: product_type, product_type_id: product_type_id }];
    this.fcs.productShare(x , this.callingfrom);
  }

  /**
   * navigate to detail
   */
  navigatetodetail(id, product_type): boolean {

    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    const actionOn = this.docCardObj.product_type == 24 ? ACTION_ON.DOCTALKS : ACTION_ON.DOCTALKS_SERIES
    if (this.parentEntityType && this.parentEntityCode) {
      const clickData: CLICK_SUB = {
        entity_type: this.parentEntityType,
        entity_code: this.parentEntityCode,
        sub_entity_type: PRODUCT_TYPE_NUMBER_MAPPING[this.docCardObj.product_type.toString()],
        sub_entity_code: this.docCardObj.doctalks_id,
        current_screen_name: this.fcs.currentScreename,
        action_on: actionOn,
        action_type: ACTION_TYPE.CLICK,
        cta_type: CTA_TYPE.SUB_CARD,
        start_time: new Date().getTime(),
        rank: 0
      };
      this.analyticSdk.analyticService.CLICK_SUB(clickData);
    }
    else {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_NUMBER_MAPPING[this.docCardObj.product_type.toString()],this.docCardObj.doctalks_id,this.fcs.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK, actionOn, null);
    }
    if (this.docCardObj.channel == null) {

      this.masterService.url_after_leave_cme = 'cme/detail/' + id;

      this.router.navigateByUrl('doctalk/detail/' + id + '/' + product_type);

    } else if (this.docCardObj.channel.is_subscribed == 0 && this.docCardObj.channel.is_product_view == 0) {
      this.channelsub = {
        docCardObj: this.docCardObj.channel,
        showSubscribeModal: true,
        callingFrom: 'doctalkCard',
        id: this.docCardObj.doctalks_id
      };

      this.dss.subscribeChannelCard.next(this.channelsub);

    } else if (this.docCardObj.channel.is_product_view == 1 || this.docCardObj.channel.is_subscribed == 1) {


      this.router.navigateByUrl('doctalk/detail/' + id + '/' + product_type);


    }

  }

  /**
   * product Bookmark
   */
  productBookmark(): void {
    if (this.feed_bookmark_loader == true) { return; }
    this.feed_bookmark_loader = true;
    const action = (this.docCardObj.is_bookmarks == 0) ? 'add' : 'delete';
    if (this.docCardObj.is_bookmarks == 0) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_NUMBER_MAPPING[this.docCardObj.product_type.toString()],this.docCardObj.doctalks_id,this.fcs.currentScreename, CTA_TYPE.ENGAGEMENT_BAR, ACTION_TYPE.CLICK, ACTION_ON.BOOKMARK, null);
    }
    this.subscriptions.add(this.postSer.productBookmark(this.docCardObj.product_type, this.docCardObj.doctalks_id, action).subscribe(resData => {
      this.feed_bookmark_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.masterService.bookmark_index.next(this.doctalkIdx);
          this.docCardObj.is_bookmarks = (action == 'add') ? 1 : 0;

          const x = { action_for: 'bookmark', product_id: this.docCardObj.doctalks_id, bookmarked: this.docCardObj.is_bookmarks };
          this.GetService.doctalkseriesbookmark.next(x);

          this.fcs.showSuccess(data['msg'], 'Success');
        } else if (data['status'] == 0) {
          this.fcs.errorHandeler(data);
          return;
        }
      }, () => {
        this.feed_bookmark_loader = false;
      });
    }));


  }

  /**
   * product Like
   */
  productLike(): void {


    if (this.feed_like_loader == true || this.docCardObj.is_like == true) { return; }
    this.feed_like_loader = true;
    this.subscriptions.add(this.postSer.productLike(this.docCardObj.product_type, this.docCardObj.doctalks_id, 'like').subscribe(resData => {
      this.runOnce = true;
      this.feed_like_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.fcs.showSuccess(data['msg'], 'Success');
          this.docCardObj.is_liked = true;

          this.docCardObj.is_like = 1;

          const x = { action_for: 'like', product_id: this.docCardObj.doctalks_id, liked: this.docCardObj.is_like };
          this.GetService.doctalkserieslike.next(x);

          this.docCardObj.like = this.docCardObj.like + 1;
          if (this.dss.isStoryLikeShareEnabled === 1) {
            this.createStoryThroughNudge(this.mls.languageText.stories_tutorial.key11, this.mls.languageText.stories_tutorial.key12, USER_STORY_NUDGE.is_story_first_like_enabled)
            this.dss.isStoryLikeShareEnabled = 0;
          }
        } else if (data['status'] == 0) {
          this.fcs.errorHandeler(data);
          return;
        }
      }, () => {
        this.feed_like_loader = false;
      });
    }));
    
    const likeData:LIKE={
      entity_type:PRODUCT_TYPE_NUMBER_MAPPING[this.docCardObj.product_type.toString()],
      entity_code: this.docCardObj.doctalks_id,
      current_screen_name: this.fcs.currentScreename,
      start_time: new Date().getTime(),
      cta_type: CTA_TYPE.ENGAGEMENT_BAR,
      action_type: ACTION_TYPE.CLICK,
      action_on: ACTION_ON.LIKE,
    }
    this.analyticSdk.analyticService.LIKE(likeData);
  }

  /**
   * navigate To Speaker detail
   */
  navigateToSpeakerdetail(id, customId): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    const clickData :CLICK = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER,
      entity_code: customId,
      current_screen_name: this.fcs.currentScreename,
      start_time: new Date().getTime(),
      action_on: ACTION_ON.TOP_SPEKAER,
      action_type: ACTION_TYPE.CLICK,
      cta_type: CTA_TYPE.CARD,
      rank: null
    }
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER,customId, this.callingfrom, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.TOP_SPEKAER, null);
    this.router.navigateByUrl('doctalk/speakers/detail/' + id);

  }

  /**
   * get Product Like List
   */
  getProductLikeList(): void {
    this.likeObj = { 'product_id': this.docCardObj.product_type_id, 'product_type': this.docCardObj.product_type, 'callLikeProperty': 'list', total_like: this.docCardObj.like };
    this.showLikeListModal = true;
  }

  /**
   * reset Like
   */
  resetLike(): void {
    this.showLikeListModal = false;
  }

  /**
   * navigate to speciality
   */
  navigatetospeciality(id): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    const clickData :CLICK = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
      entity_code: 0,
      current_screen_name: this.fcs.currentScreename,
      start_time: new Date().getTime(),
      action_on: ACTION_ON.SPECIALITY,
      action_type: ACTION_TYPE.CLICK,
      cta_type: CTA_TYPE.CARD,
      rank: null
    }
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.OTHER,0, this.callingfrom, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.SPECIALITY, null);
    this.router.navigateByUrl('doctalk/speciality/list/' + id);

  }

  /**
   * get Single Speciality
   */
  getSingleSpeciality(speciality): string {
    const x = speciality.split(',');
    let y = '';
    y = (x.length > 1) ? x[0] + ' +' + (x.length - 1) : '';
    return y;
  }

  /**
   * reset NgbDDL Record
   */
  resetNgbDDLRecord(): void {
    // No Code
  }

  /**
   * reset Subscribe Modal
   */
  resetSubscribeModal(): void {
    this.showSubscribeModal = false;
  }

  /**
   * Function is used to get specialty.
   */
  getSpecialty(speciality): void {
    this.analyticSdk.analyticService.CLICK( PRODUCT_TYPE_NUMBER_MAPPING[this.docCardObj.product_type.toString()],this.docCardObj.product_type_id,this.fcs.currentScreename, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, ACTION_ON.SPECIALITY_HASTAG, null);
    this.dss.specialty_filter = speciality;
    this.router.navigate(['/web/list']);
  }

  /**
   * repost wbinar as story
   */
  repostAsStory(): void {
    this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.DOCTALKS;
    this.dss.user_story_productTypeId = this.docCardObj.product_type_id;
    this.dss.create_Story_productData.next(this.docCardObj);
    this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
    this.dss.storyType = CREATE_STORY_TYPES.REPOST;
    this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
    this.dss.create_Story.next(true);
  }
  /**
   * create story through nudge
   */
  createStoryThroughNudge(storyNudgeHeading, storyNudgeDisc, nudgeType ): void {
    this.dss.create_Story_productData.next(this.docCardObj);
    this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.FEED;
    this.dss.user_story_productTypeId = this.docCardObj.product_type_id;
    this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
    this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
    this.dss.storyType = CREATE_STORY_TYPES.REPOST;
    this.dss.storyNudgeIcon = 'assets/images/webinar-nudge.png';
    this.dss.storyNudgeHeading = storyNudgeHeading;
    this.dss.storyNudgeDisc = storyNudgeDisc,
    this.dss.storyNudgeButton = this.mls.languageText.stories_tutorial.key16;
    this.dss.story_nudge_type = nudgeType;
    this.dss.userStoryNudge.next(true);
  }
  /**
   * repost as story
   */
  repostDoctalkType(event): void {
    if (event === REPOST_TYPE_ITEM.REPOST_ON_FEED) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_NUMBER_MAPPING[this.docCardObj.product_type],this.docCardObj.product_type_id,
        this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_FEED, null);
      this.repostDoctalk();
    }
    else if (event === REPOST_TYPE_ITEM.REPOST_AS_STORY) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_NUMBER_MAPPING[this.docCardObj.product_type],this.docCardObj.product_type_id,
        this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_STORY, null);
      if (this.dss.user_profile_data.profile.permission != 'all') {
        this.fcs.assignAssociation('');
        return;
      }
      this.repostAsStory();
    }
  }
  /**
   * Repost webinar card
   */
  repostDoctalk(): void {
    if(this.dss.post_process_obj.status === POSTING_PROGRESS.IN_PROGRESS){
      this.fcs.showError('', this.mls.languageText.feed_card_screen.key22);
      return;
    }
    this.dss.repostProductId = this.docCardObj.product_type_id;
    this.dss.repostProductType = PRODUCT_TYPE_CONSTANT.DOCTALKS;
    this.dss.isRepostStatus = REPOST_STATUS.ONE;
    this.fcs.navigateToFeedDetail(NUMBERS.ZERO);
    this.dss.show_feed_post_modal.next(1);
    this.dss.webinarRepostObject = this.docCardObj;
    this. closeRepostTooltip();
  }
  /**
   * Close repost tooltip
   */
  closeRepostTooltip(): void {
    this.showRepostPopOver = false;
    this.setLocalStorageIsRepostPopover();
    this.subscriptions.add(this.postSer.logTutorialView(POST_TYPE.REPOST).subscribe(data =>{
      //  no code
    })
    );
  }

  /**
   * Set the repopst info popover status in local storage.
   */
  setLocalStorageIsRepostPopover(): void {
    localStorage.setItem(REPOST_INFO_LOCAL_STORAGE.KEY, REPOST_INFO_LOCAL_STORAGE.VALUE);
  }
  /**
   * Emit the generated meta.
   */
  onGenerateMeta(status: boolean): void {
    this.isMetaGenerated = status;
  }
  /**
   * show repost types
   */
  generateMeta(): void{
  this.fcs.checkRepostPopOver('',this.docCardObj?.channel?.community_id, this.docCardObj?.hl?.tcf);
  this.analyticSdk.analyticService.CLICK( PRODUCT_TYPE_NUMBER_MAPPING[this.docCardObj.product_type.toString()],this.docCardObj.doctalks_id,this.fcs.currentScreename, CTA_TYPE.ENGAGEMENT_BAR, ACTION_TYPE.CLICK, ACTION_ON.REPOST, null);
    this.isMetaGenerated = true;


  }
  /**
   * close posting meta
   */
  closeMeta(event): void{
    this.fcs.isShowFeedRepost = true;
    this.isMetaGenerated = false;
  }
  /**
   * Emit action on generated Meta.
   */
  onMeta(deepLink: string): void {
    console.log(deepLink);
      // this.emitOnMeta.emit(deepLink);
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
